// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".horizontalSide-logo[data-v-1f162bd8] {\n  height: 54px;\n  line-height: 54px;\n  width: 240px;\n}\n.side-main[data-v-1f162bd8] {\n  width: calc(100% - 240px);\n  height: 54px;\n  line-height: 54px;\n  background: #293348;\n  float: right;\n}", ""]);
// Exports
module.exports = exports;
